import { FormFields, Icons, Label } from "components";

const RewardSharedGoal = ({ control, disabled }) => {
  return (
    <div className="row_2col" >
      <div>
        <FormFields.FormTextField
          theme_standard_new
          control={control}
          label="รางวัลเมื่อภารกิจสำเร็จ"
          subLabel="Reward"
          name="success_coin_amount"
          disabled={disabled}
          required
          iconInlinePrefix={
            <Label.LabelInlineIcon theme_standard_label_inline_icon icon={<Icons.Dumbel2 />} label="คะแนนสุขภาพ" />
          }
          iconRight="แต้ม"
          maxLength={4}
          useComma
          type="number"
          placeholder="คะแนน"
          paddingInput="11.5px"
        />
      </div>
      <div>
        <FormFields.FormTextField
          theme_standard_new
          control={control}
          label="รางวัลปลอบใจสำหรับผู้ที่ไม่ผ่านภารกิจ"
          subLabel="Consolation Reward"
          name="fail_coin_amount"
          disabled={disabled}
          required
          iconInlinePrefix={
            <Label.LabelInlineIcon theme_standard_label_inline_icon icon={<Icons.Dumbel2 />} label="คะแนนสุขภาพ" />
          }
          iconRight="แต้ม"
          useComma
          type="number"
          maxLength={4}
          placeholder="คะแนน"
          paddingInput="11.5px"
        />
      </div>
    </div>
  );
};

export default RewardSharedGoal;
